import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface TermsConditionsProps {
  onBack: () => void;
}
export function TermsConditions({
  onBack
}: TermsConditionsProps) {
  return <div className="min-h-screen bg-white" data-id="element-414">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-200 z-50" data-id="element-415">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-416">
          <button onClick={onBack} className="flex items-center text-gray-600 hover:text-[#00E676] transition-colors" data-id="element-417">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-418" />
            Back to Home
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-419">
        <div className="space-y-8 text-gray-700 leading-relaxed" data-id="element-420">
          <div data-id="element-421">
            <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-422">
              Terms & Conditions
            </h1>
            <p className="text-sm text-gray-600" data-id="element-423">
              Last Updated: December 16, 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-424">
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-425">
              BRIXEN FUNDING LLC - TERMS AND CONDITIONS
            </h2>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-426">
              1. AGREEMENT TO TERMS
            </h3>
            <p data-id="element-427">
              These Terms and Conditions ("Terms") constitute a legally binding
              agreement made between you ("Client," or "User") and Brixen
              Funding LLC ("we," "us," or "our"), concerning your access to and
              use of our website (the "Site") and our brokerage services. By
              accessing the Site or submitting an application for funding, you
              agree to be bound by these Terms and our Privacy Policy.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-428">
              2. SERVICES PROVIDED: WE ARE A BROKER, NOT A LENDER
            </h3>
            <p className="mb-3" data-id="element-429">
              Brixen Funding LLC operates strictly as a commercial finance
              broker and consultant.
            </p>
            <p className="mb-2" data-id="element-430">
              <strong data-id="element-431">No Lending Authority:</strong> We are not a direct lender,
              bank, or financial institution. We do not underwrite loans, make
              credit decisions, issue loan commitments, or fund loans.
            </p>
            <p className="mb-2" data-id="element-432">
              <strong data-id="element-433">The Service:</strong> Our role is limited to connecting
              you with our network of third-party lenders ("Funding Partners").
            </p>
            <p data-id="element-434">
              <strong data-id="element-435">No Guarantees:</strong> We do not guarantee that you will
              be approved for any loan, nor do we guarantee specific terms,
              rates, or funding amounts.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-436">
              3. USER REPRESENTATIONS AND OBLIGATIONS
            </h3>
            <p data-id="element-437">
              By using our Services, you represent that: (1) You are at least 18
              years of age; (2) All information you submit is true, accurate,
              current, and complete; and (3) You are seeking funding solely for
              commercial or business purposes, not for personal use.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-438">
              4. AUTHORIZATION FOR CREDIT CHECKS AND DATA SHARING
            </h3>
            <p className="mb-3" data-id="element-439">
              You expressly authorize us and our Funding Partners to:
            </p>
            <p className="mb-2" data-id="element-440">
              <strong data-id="element-441">Credit Inquiries:</strong> Obtain consumer and/or business
              credit reports (soft or hard pulls) from credit bureaus.
            </p>
            <p data-id="element-442">
              <strong data-id="element-443">Data Sharing:</strong> Share your business information
              with lenders solely for the purpose of securing funding.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-444">
              5. MESSAGING TERMS & CONDITIONS (TCPA COMPLIANCE)
            </h3>
            <p className="mb-3" data-id="element-445">
              By providing your mobile phone number and opting in, you consent
              to receive recurring automated calls and text messages (SMS/MMS)
              from Brixen Funding LLC regarding your application status,
              document requests, and account updates.
            </p>
            <p className="mb-2" data-id="element-446">
              <strong data-id="element-447">Consent:</strong> Consent to receive text messages is not
              a condition of any purchase or service approval.
            </p>
            <p className="mb-2" data-id="element-448">
              <strong data-id="element-449">Frequency:</strong> Message frequency varies based on your
              application status.
            </p>
            <p className="mb-2" data-id="element-450">
              <strong data-id="element-451">Rates:</strong> Message and data rates may apply depending
              on your mobile carrier plan.
            </p>
            <p className="mb-2" data-id="element-452">
              <strong data-id="element-453">Help:</strong> For assistance, reply HELP to any message
              or contact us at info@brixenfunding.com.
            </p>
            <p className="mb-2" data-id="element-454">
              <strong data-id="element-455">Opt-Out:</strong> To stop receiving text messages, reply
              STOP at any time. You will receive a final confirmation message,
              and then no further messages will be sent.
            </p>
            <p data-id="element-456">
              <strong data-id="element-457">Carriers:</strong> Carriers are not liable for delayed or
              undelivered messages.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-458">
              6. DISCLAIMER OF WARRANTIES
            </h3>
            <p data-id="element-459">
              THE SITE AND SERVICES ARE PROVIDED ON AN "AS-IS" BASIS. WE
              DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED. WE DO NOT WARRANT
              THAT THE SITE WILL BE ERROR-FREE.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-460">
              7. LIMITATION OF LIABILITY
            </h3>
            <p data-id="element-461">
              IN NO EVENT SHALL BRIXEN FUNDING LLC BE LIABLE FOR ANY DIRECT,
              INDIRECT, CONSEQUENTIAL, OR INCIDENTAL DAMAGES ARISING FROM YOUR
              USE OF THE SITE OR ANY DECISION MADE BY A THIRD-PARTY LENDER.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-462">
              8. INDEMNIFICATION
            </h3>
            <p data-id="element-463">
              You agree to defend, indemnify, and hold harmless Brixen Funding
              LLC from any loss, damage, liability, or claim arising out of your
              use of the Site or breach of these Terms.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-464">
              9. GOVERNING LAW
            </h3>
            <p data-id="element-465">
              These Terms shall be governed by the laws of the State of Florida.
              Any dispute shall be resolved through binding arbitration in
              Miami-Dade County, Florida.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3" data-id="element-466">
              10. CONTACT US
            </h3>
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mt-4" data-id="element-467">
              <p className="font-semibold text-gray-900" data-id="element-468">Brixen Funding LLC</p>
              <p data-id="element-469">390 NE 191st St</p>
              <p data-id="element-470">Miami, FL 33179</p>
              <p data-id="element-471">(786) 272-6132</p>
              <p data-id="element-472">info@brixenfunding.com</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 border-t border-gray-200 py-8 mt-16" data-id="element-473">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-474">
          <button onClick={onBack} className="inline-flex items-center text-[#00E676] hover:text-[#00d169] font-semibold transition-colors" data-id="element-475">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-476" />
            Return to Home
          </button>
        </div>
      </div>
    </div>;
}